
import FilterDropdown from "@/components/FilterDropdown/FilterDropdown.vue";
import { Component, Watch } from "vue-property-decorator";
import Vue from "vue";
import { Api } from "@/api/Api";
import { getModule } from "vuex-module-decorators";
import FilterModule from "@/store/modules/FilterModule";
import MemberModule from "@/store/modules/MemberModule";
import { DropdownData } from "@/models/DropdownData";
import ContentModule from "@/store/modules/ContentModule";
import $ from "jquery";
import SearchModule from "@/store/modules/SearchModule";

@Component({
  components: {
    FilterDropdown,
  },
})
export default class FeedbackForm extends Vue {
  $refs!: {
    fileUpload: HTMLInputElement;
  };

  private readonly variantFilterModule = getModule(FilterModule, this.$store);
  private readonly memberModule = getModule(MemberModule, this.$store);
  private readonly contentModule = getModule(ContentModule, this.$store);
  private readonly searchModule = getModule(SearchModule, this.$store);

  private readonly dropdownIdWorkRole = "WorkRole";
  private readonly dropdownIdFeedbackArea = "FeedbackArea";
  private readonly dropdownIdFeedbackType = "FeedbackType";

  name = "";
  feedbackWorkRole: DropdownData<string> | null = null;
  feedbackType: DropdownData<string> | null = null;
  feedbackArea: DropdownData<string> | null = null;
  feedbackSent = false;
  feedbackMessage = "";
  feedbackFile!: File;
  sending = false;
  closing = false;
  error = "";
  maxFileUploadSize = 2; // MB

  get feedbackFormOpen(): boolean {
    return this.contentModule.feedbackFormOpen;
  }

  get searchModalOpen(): boolean {
    return this.searchModule.searchModalOpen;
  }

  get componentClasses(): string {
    let classes = [];

    if (this.feedbackFormOpen) {
      classes.push("open");
    }
    if (this.searchModalOpen) {
      classes.push("search-open");
    }

    if (this.feedbackSent) {
      classes.push("feedback-sent");
    }

    if (this.closing) {
      classes.push("closing");
    }

    return classes.join(" ");
  }

  get submitBtnClasses(): string {
    const classes = [];

    classes.push("btn small primary");

    if (this.sending) {
      classes.push("loading");
    }

    return classes.join(" ");
  }

  get inputValid(): boolean {
    return (
      this.name.length > 0 &&
      this.feedbackWorkRole !== null &&
      this.feedbackArea !== null &&
      (this.feedbackType !== null || this.feedbackArea.value === "Other") &&
      this.feedbackMessage.length > 0
    );
  }

  get feedbackTypeActive(): boolean {
    return this.feedbackArea !== null && this.feedbackArea.value !== "Other";
  }

  get workRoleChoices(): DropdownData<string>[] {
    let data = [];

    data.push(
      this.getDropDownItem(this.dropdownIdWorkRole, "Technician"),
      this.getDropDownItem(this.dropdownIdWorkRole, "TechnicalSupport"),
      this.getDropDownItem(this.dropdownIdWorkRole, "TechnicalTrainer"),
      this.getDropDownItem(this.dropdownIdWorkRole, "RandD"),
      this.getDropDownItem(this.dropdownIdWorkRole, "Other")
    );

    return data;
  }

  get feedbackAreaChoices(): DropdownData<string>[] {
    let data = [];

    data.push(
      this.getDropDownItem(this.dropdownIdFeedbackArea, "System"),
      this.getDropDownItem(this.dropdownIdFeedbackArea, "Content"),
      this.getDropDownItem(this.dropdownIdFeedbackArea, "Translation"),
      this.getDropDownItem(this.dropdownIdFeedbackArea, "Other")
    );

    return data;
  }

  get feedbackTypeChoices(): DropdownData<string>[] {
    let data: DropdownData<string>[] = [];

    if (!this.feedbackArea) {
      return [];
    }

    switch (this.feedbackArea.value) {
      case "System":
        data.push(
          this.getDropDownItem(this.dropdownIdFeedbackType, "Account"),
          this.getDropDownItem(this.dropdownIdFeedbackType, "Functionality"),
          this.getDropDownItem(this.dropdownIdFeedbackType, "Other")
        );
        break;
      case "Content":
      case "Translation":
        data.push(
          this.getDropDownItem(this.dropdownIdFeedbackType, "Wrong"),
          this.getDropDownItem(this.dropdownIdFeedbackType, "Missing"),
          this.getDropDownItem(this.dropdownIdFeedbackType, "Other")
        );
        break;
      default:
        data.push(this.getDropDownItem(this.dropdownIdFeedbackType, "Other"));
        break;
    }

    return data;
  }

  // ...mapActions(["openFeedbackForm", "closeFeedbackForm"]),

  private getDropDownItem(id: string, value: string): DropdownData<string> {
    return new DropdownData<string>(id, this.$t.getLocalizedString(`Feedback${value}`), value);
  }

  onFileAdded() {
    // Name of file and placeholder
    const $el = $(this.$refs.fileUpload);
    if (!this.$refs.fileUpload.files) {
      return;
    }

    this.feedbackFile = this.$refs.fileUpload.files[0];

    this.validateFile();

    if (this.feedbackFile) {
      $el.next().text(this.feedbackFile.name);
    } else {
      $el.next().text(this.$t.FeedbackAttachFile);
    }
  }

  validateFile(): boolean {
    if (this.feedbackFile && this.feedbackFile.size / 1024 / 1024 > this.maxFileUploadSize) {
      this.error = `Maximum file size is ${this.maxFileUploadSize} MB.`;
      return false;
    } else {
      this.error = "";
      return true;
    }
  }

  toggleFeedbackForm() {
    if (this.feedbackFormOpen) {
      this.closing = true;
      this.closeFeedbackForm();

      setTimeout(() => {
        this.closing = false;
        this.feedbackSent = false;
      }, 800);
    } else {
      this.openFeedbackForm();
    }
  }

  private closeFeedbackForm() {
    this.contentModule.setFeedbackFormOpen(false);
  }

  private openFeedbackForm() {
    this.contentModule.setFeedbackFormOpen(true);
  }

  async sendFeedback() {
    this.error = "";

    if (!this.validateFile()) {
      return;
    }

    if (this.feedbackWorkRole === null || this.feedbackArea === null || this.feedbackType === null) {
      return;
    }

    this.sending = true;

    // const formData = new FormData();
    // formData.append("name", this.name);
    // formData.append("workRole", this.feedbackWorkRole.value);
    // formData.append("area", this.feedbackArea.value);
    // formData.append("type", this.feedbackType.value);
    // formData.append("message", this.feedbackMessage);
    // formData.append("attachment", this.feedbackFile);

    const formData = {
      name: this.name,
      workRole: this.feedbackWorkRole.value,
      area: this.feedbackArea.value,
      type: this.feedbackType.value,
      message: this.feedbackMessage,
    };

    try {
      const result = await Api.sendFeedback(
        window.location.href,
        formData,
        this.variantFilterModule.activeFilters
      );

      this.feedbackSent = true;
      this.sending = false;

      if (result) {
        setTimeout(() => {
          this.feedbackSent = false;
          this.closing = true;
          this.closeFeedbackForm();

          setTimeout(() => {
            this.closing = false;
          }, 800);
        }, 3000);
      } else {
        this.feedbackSent = false;
        this.sending = false;
        this.error = "Something went wrong. Please try again.";
      }
    } catch (error) {
      this.feedbackSent = false;
      this.sending = false;
      this.error = "Something went wrong. Please try again.";
      console.error(error);
    }
  }

  onDropdownChange(target: DropdownData<string>) {
    let tgtItem;
    const dropdownTarget = target.id;
    const targetValue = target.value;
    
    switch (dropdownTarget) {
      case "WorkRole":
        this.feedbackWorkRole = target;
        // tgtItem = this.workRoleChoices.find(
        //     (item) => item.id === targetValue
        // );
        // if (tgtItem !== undefined && targetValue !== this.feedbackWorkRole) {
        //   this.feedbackWorkRole = targetValue;
        // }
        break;
      case "FeedbackArea":
        this.feedbackArea = target;

        this.feedbackType =
          this.feedbackArea.value === "Other"
            ? this.feedbackTypeChoices.find((c) => c.value === "Other") || null
            : null;

        // tgtItem = this.feedbackAreaChoices.find(
        //     (item) => item.id === targetValue
        // );
        //
        // if (tgtItem !== undefined && targetValue !== this.feedbackArea) {
        //   this.feedbackArea = targetValue;
        //   this.feedbackType = this.feedbackArea === "Other" ? "Other" : "";
        // }
        break;
      case "FeedbackType":
        this.feedbackType = target;
        // tgtItem = this.feedbackTypeChoices.find(
        //     (item) => item.id === targetValue
        // );
        //
        // if (tgtItem !== undefined && targetValue !== this.feedbackType) {
        //   this.feedbackType = targetValue;
        // }
        break;
    }
  }
}
